import { MatDialog } from "@angular/material/dialog";
import { ModalsComponent } from "./modals.component";
import { ItineraryService } from "../itinerary.service";
import { MaterialModalConfirmComponent } from "../material-modal-confirm/material-modal-confirm.component";
import { InsuranceQuoteModalComponent } from "./insurance-quote/insurance-quote-modal.component";

export function openModalResult(
                                product: any,
                                payload: any,
                                quote: boolean,
                                dialog: MatDialog,
                                paymentAgencyActive: any,
                                actualItinerary: any,
                                modalRef: any,
                                tabActive: string,
                                category: number,
                                clientSetting: any,
                                currencyAgency: any,
                                currencies: any,
                                itineraryService: ItineraryService,
                                action: string
                              ): void {

  if(!payload || !product) {
    console.warn('Falta informacion en el producto');
      return;
  }

  if(!category) {
      console.warn('No hay categoría definida');
      return;
  }

      product.productId = product?.octopus_id ? product?.octopus_id.toString() : product?.idProduct;

       switch(category) {
          case 1:
            var dialogRef = dialog.open(ModalsComponent, {
                width: "920px",
                panelClass: 'custom-container-transport',
                disableClose: true,
                 data: {
                  modalRoomRef: modalRef,
                  product: product,
                  departureDate: payload.products[0].departureDate,
                  arrivalDate: payload.products[0].arrivalDate,
                  productQty: payload.products[0].qtyProduct,
                  form: product.form,
                  origin: "HOTELS",
                  arrayResults: [{searchId: product.searchId, component: 'suggestion_itinerary'}],
                  tabActive: tabActive,
                  payloadUpdate: payload.products[0],
                  paymentAgencyActive: paymentAgencyActive,
                  quote: quote,
                  action: action
                },
            })
            break;
          case 2:
            var dialogRef = dialog.open(ModalsComponent, {
               height: "680px",
               width: "970px",
              data: {
              modalRoomRef: modalRef,
              product: product,
              productQty: payload.qtyProduct,
              form: product.form,
              origin: "RENT-A-CAR",
              arrayResults: [product] ,
              tabActive: tabActive,
              payloadUpdate: payload,
              quote: quote,
              action: action
            },
            });
            break;
          case 6:
          case 9:
            var dialogRef = dialog.open(ModalsComponent, {
                    height: '680px',
                    width: '860px',
                    data: {
                      modalRoomRef: modalRef,
                      product: product,
                      productQty: payload,
                      // form: this.form,
                      origin: 'TOURS',
                      arrayResults: [{searchId: product.searchId, component: 'suggestion_itinerary'}],
                      tabActive: tabActive,
                      payloadUpdate: payload,
                      paymentAgencyActive: paymentAgencyActive,
                      quote: quote,
                      action: action
                    },
                    disableClose: false
                  });
            break;
          case 8:
            console.log(product)
            let formTransport: any;

            if(quote) {
               formTransport = {
                  dropoff: '',
                  firstArrivalDate: payload.pickupDate,
                  firstDestination: {
                    address: payload.transfers.pickupLocation.address,
                    city_name: '',
                    country_code: '',
                    country_name: '',
                    id: payload.transfers.pickupLocation.id,
                    name: '',
                    province: '',
                    type: payload.transfers.type,
                  },
                  firstOrigin: {
                    address: payload.transfers.dropoffLocation.address,
                    city_name: '',
                    country_code: '',
                    country_name: '',
                    id: payload.transfers.dropoffLocation.id,
                    name: '',
                    province: '',
                    type: payload.transfers.dropoffLocation.type,
                  },
                  firstTime:'',
                  firstChildsage: payload.transfers.paxList.children,
                  firstQtyChilds:payload.transfers.paxList.children.length,
                  firstQtyAdults: payload.transfers.paxList.adults,
                  pickUp: '',
                  secondArrivalDate: null,
                  secondTime: null,
                  type: 'oneTrip'
                };
            } else {
              formTransport = product.formTransport;
              product.vehicles = [product];

            }

            var dialogRef = dialog.open(ModalsComponent, {
                height: "680px",
                width: "1100px",
                panelClass: 'custom-container-transport',
                disableClose: true,
                data: {
                  vehicles: product?.vehicles,
                  product: product?.vehicles,
                  departureDate: payload.departureDate,
                  productQty: payload.qtyProduct,
                  flyingInfo: actualItinerary?.fly,
                  formTransport: formTransport,
                  form: formTransport,
                  // form: this.form,
                  origin: "TRANSPORTS",
                  arrayResults:  [{searchId: product.searchId, component: 'suggestion_itinerary'}],
                  tabActive: tabActive,
                  payload: payload,
                  paymentAgencyActive: paymentAgencyActive,
                  quote: quote,
                  action: action
                },
              });
            break;
            case 10:

            let insurancePlan: any;
            if(quote) {
                insurancePlan = product;
            } else {
              insurancePlan = [
                    {insurance:
                      {plan: product}
                    }
                  ]
            }

            // dialog.open(MaterialModalConfirmComponent, {
            //     width: 'auto',
            //     minWidth: '650px',
            //     data: {
            //       message: '',
            //       type: 'material',
            //       clientSetting: clientSetting,
            //       currencies: currencies,
            //       currencyAgency: currencyAgency,
            //       insurancePlan: insurancePlan,
            //       quote: quote
            //     },
            //     disableClose: true
            //   });
            let message: string = '';
                dialog.open(InsuranceQuoteModalComponent, {
                  width: 'auto',
                  maxWidth: '1440px',
                  panelClass: 'insurance-quote-modal-wide',
                  data: {
                    message: message,
                    type: 'material',
                    clientSetting: clientSetting,
                    currencies: currencies,
                    currencyAgency: currencyAgency,
                    insurancePlan: insurancePlan,
                    quote: quote
                  },
                  disableClose: false
                });


            break;
            default: console.warn('No hay categoria definida');
            break;
        }

      // dialogRef.afterClosed().subscribe((result: any) => {

      //               if(result === 'success' || result === 'add') {
      //                 this.reloadEmmit.emit();
      //               }
      //             })
  }
